import {
  FeatureFlagRuleModel,
  FeatureFlagRuleTableEntry,
} from "@modules/feature-flag/feature-flag-types.ts";

export const FEATURE_FLAG_NAME = {
  HOMEPAGE: "HOMEPAGE",
} as const;

export const FEATURE_FLAG_RULE_CATEGORY_OPTION = {
  LEVEL_AND_STREAM: "LEVEL_AND_STREAM",
  STUDENT_GROUP: "STUDENT_GROUP",
} as const;

export const FEATURE_FLAG_RULE_SCHOOL_OPTION = {
  ALL: "ALL",
  SPECIFIC: "SPECIFIC",
} as const;

export function mapRulesToTableEntries(rules: FeatureFlagRuleModel[]): FeatureFlagRuleTableEntry[] {
  return rules.map((rule) => {
    const school = rule.schoolId == null ? "All Schools" : (rule.schoolName ?? ""); //change to label

    // If studentGroupId exists, prioritise Group
    if (rule.studentGroupId != null) {
      return {
        id: rule.id,
        school,
        name: rule.studentGroupName ?? "",
        type: "Group",
      };
    }

    const name = rule.levelAndStreamId == null ? "All Levels" : (rule.levelStreamName ?? "");
    return {
      id: rule.id,
      school,
      name,
      type: "Level",
    };
  });
}
